import axiosInstanceNew from "../lib/axiosinstanceNew";

const FeedBack = class {
    constructor() {
        this.baseUrl = "feedback";
    }

  async List(query = []) {
    return (await axiosInstanceNew.get(`${this.baseUrl}?${new URLSearchParams(query)}`)).data;
  }
  
}

export default new FeedBack();